<ng-container>
    <span [style.display]="display ? 'block' : 'none'" class="with-icon">
        <mat-icon svgIcon="error-icon" class="in-error"></mat-icon>
        {{ message }}
    </span>
</ng-container>
